import { useTranslation } from 'react-i18next';
import AboutSection from '../components/home/AboutSection/AboutSection';
import HomeHero from '../components/home/HomeHero/HomeHero';
import NumbersSection from '../components/home/NumbersSection/NumbersSection';
import ServicesSection from '../components/home/ServicesSection/ServicesSection';
import WorkSection from '../components/home/WorkSection/WorkSection';
import ContactSection from '../components/site/ContactSection/ContactSection';
import { usePageMeta } from '../hooks/usePageMeta';

export default function Home() {
    const { t } = useTranslation();
    usePageMeta(t('meta.homeTitle'), t('meta.homeDescription'));

    return (
        <>
            <HomeHero />
            <AboutSection />
            <ServicesSection />
            <WorkSection />
            <NumbersSection />
            <ContactSection />
        </>
    );
}
